@if (uploading) {
  <app-add-respondent-loading-state></app-add-respondent-loading-state>
} @else {
  <div class="flex items-center justify-between gap-4">
    <h3
      mat-dialog-title
      class="!m-0"
      data-test-id="data-capture-add-expert-title"
    >
      Add experts
    </h3>
    <button
      mat-icon-button
      mat-dialog-close
      data-test-id="data-capture-add-expert-close-button"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <mat-dialog-content
    class="flex min-w-0 flex-col overflow-x-hidden px-6 pb-4 pt-2"
  >
    @if (loading || validating) {
      <app-loader></app-loader>
    } @else {
      <app-add-respondent-bulk-workflow
        class="min-w-0"
        [bulkUploadStep]="bulkUploadStep"
        [bulkDragActive]="bulkDragActive"
        [bulkStaging]="bulkStaging"
        [unassignedFiles]="unassignedFiles"
        [respondentsArray]="respondentsArray"
        [segments]="segments"
        [submitted]="addRespondentFormGroupSubmitted"
        [rowUploadErrorLookup]="rowUploadErrorLookup"
        [clearRowUploadError]="clearRowUploadErrorLookup"
        (uploadStepSelected)="goToBulkUploadStep()"
        (reviewStepSelected)="goToBulkReviewStep()"
        (bulkFilesChange)="onBulkFilesChange($event)"
        (bulkDragOver)="onBulkDragOver($event)"
        (bulkDragLeave)="onBulkDragLeave($event)"
        (bulkDrop)="onBulkDrop($event)"
        (clearUnassigned)="clearUnassignedFiles()"
        (addExpertWithoutFiles)="onAddExpertWithoutFiles()"
      >
      </app-add-respondent-bulk-workflow>
    }
  </mat-dialog-content>

  @if (!loading && isBulkReviewStep) {
    <div class="w-full min-w-0 px-6 pb-2">
      <mat-checkbox
        class="block w-full"
        data-test-id="data-capture-add-expert-compliance-checkbox"
        [formControl]="complianceControl"
      >
        <span
          class="block whitespace-normal text-xs leading-5"
          data-test-id="data-capture-add-expert-compliance-label"
          [class.text-rose-600]="
            complianceControl.invalid && complianceControl.touched
          "
          [class.text-slate-600]="
            !(complianceControl.invalid && complianceControl.touched)
          "
        >
          By uploading a third party file to the platform I am agreeing to the
          T&Cs of the Techspert Platform License Agreement
        </span>
      </mat-checkbox>
    </div>

    <mat-dialog-actions class="flex flex-col gap-2 px-6 pt-2 gt-xs:flex-row">
      <button
        class="flex-1"
        mat-stroked-button
        color="primary"
        type="button"
        data-test-id="data-capture-add-expert-back-button"
        (click)="goToBulkUploadStep()"
      >
        Back
      </button>
      <button
        class="flex-1"
        mat-flat-button
        color="primary"
        data-test-id="data-capture-add-expert-confirm-button"
        [disabled]="validating || bulkStaging || !canSubmit"
        (click)="submit()"
      >
        Confirm
      </button>
    </mat-dialog-actions>
  }
}
